import React from 'react';

const SharePeopleCollectionIcon = () => (
  <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.34049 2.78346V0L10.4815 3.0272L13 5.45437L10.4368 7.51302L7.34049 10V7.27635C1.90452 6.88147 0 9.91318 0 9.91318C0 8.02431 0.161489 6.06406 1.70232 4.57972C3.4934 2.85292 6.08726 2.73072 7.34049 2.78346Z" fill="currentColor" />
  </svg>
);

export default SharePeopleCollectionIcon;
